// utils/request.js
const baseURL = 'https://ml.zhuoruiapp.com/api/Information';

export const request = async (url, options = {}) => {

    const config = {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    };

    const response = await fetch(`${baseURL}${url}`, config);
    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.message || '请求失败');
    }

    return data;
};

// 便捷方法
export const get = (url, params) => {
    const queryString = params ? '?' + new URLSearchParams(params) : '';
    return request(`${url}${queryString}`);
};

export const post = (url, data) => {
    return request(url, {
        method: 'POST',
        body: JSON.stringify(data),
    });
};